import Box from '@mui/material/Box';

import logo from 'assets/logo.svg';

import { colors } from 'styles';

import { HeaderStyled, HeaderNavigation } from './Header.style';
import { NavigationItem } from './DesktopHeader.style';
import { ContactUsButton, LogoLink } from './MobileHeader.style';

import { Link } from 'react-router-dom';
import { homeMeta, resourcesMeta } from 'constants/pages';
import { useContext } from 'react';
import { ScrollContext } from 'context/ScrollContext';
import { Dropdown } from './Dropdown';
import { industriesItems, applicationsItems, companyItems, customerCasesItems, platformItems } from './constants';

const pagesWithoutBlurredHeader = ['/articles/', '/privacy-policy'];

type DesktopHeaderProps = { openModal: () => void };

export const DesktopHeader = ({ openModal }: DesktopHeaderProps) => {
  const isScrolled = useContext(ScrollContext);
  const isPageWithoutBlurredHeader = pagesWithoutBlurredHeader.some((path) =>
    location.pathname.includes(path),
  );
  const color = isScrolled || isPageWithoutBlurredHeader ? colors.darkGray : colors.white;
  const activeColor =
    isScrolled || isPageWithoutBlurredHeader
      ? 'rgba(52, 142, 233, 0.20)'
      : 'rgba(255, 255, 255, 0.2)';

  return (
    <HeaderStyled component="header" isScrolled={isScrolled || isPageWithoutBlurredHeader}>
      <HeaderNavigation component="nav">
        <Box mr="auto">
          <LogoLink to={homeMeta.url}>
            <img src={logo} alt="logo icon" />
          </LogoLink>
        </Box>

        <Box width="100%" justifyContent="center" alignItems="center" display="flex">
          <Dropdown
            isScrolled={isScrolled}
            label="Platform"
            items={platformItems}
            color={color}
            isActive={location.pathname.startsWith('/platform')}
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Industries"
            items={industriesItems}
            color={color}
            isActive={
              location.pathname.startsWith('/Industries') || location.pathname === '/all-industries'
            }
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Applications"
            items={applicationsItems}
            color={color}
            isActive={
              location.pathname.startsWith('/applications') ||
              location.pathname === '/all-applications'
            }
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Customer Cases"
            items={customerCasesItems}
            color={color}
            isActive={
              location.pathname.startsWith('/customer-case') ||
              location.pathname === '/all-customer-cases'
            }
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Dropdown
            isScrolled={isScrolled}
            label="Company"
            items={companyItems}
            color={color}
            isActive={location.pathname.startsWith('/company')}
            activeColor={activeColor}
            anchorVerticalOrigin={68}
          />

          <Box mr={1}>
            <NavigationItem
              color={color}
              isActive={location.pathname === resourcesMeta.url}
              activeColor={activeColor}
            >
              <Link to={resourcesMeta.url} style={{ textDecoration: 'none', color: 'inherit' }}>
                Resources
              </Link>
            </NavigationItem>
          </Box>
        </Box>

        <ContactUsButton
          onClick={openModal}
          color="secondary"
          variant={isScrolled ? 'outlined' : 'contained'}
          style={{ width: '120px', height: '50px', fontSize: '14px' }}
        >
          Contact us
        </ContactUsButton>
      </HeaderNavigation>
    </HeaderStyled>
  );
};
